export default __webpack_public_path__ + "static/media/archetypewinterface.77972781.png";